var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSigned(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46.433,
    height: 39.029,
    viewBox: "0 0 46.433 39.029",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ae236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8acd2e"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "signed",
    d: "M3670.446,8105.606v-25.492c0-.655.3-1.425.959-1.425h24.728c.656,0,.959.77.959,1.425v1.906h-2.378v-.953h-21.89v24.539a2.736,2.736,0,1,0,5.236,0v-3.954a1.219,1.219,0,0,1,1.321-1.075h15.333v-4.283h2.378v4.283h7.017a1,1,0,0,1,1.073,1.075v3.954a5.86,5.86,0,0,1-6.258,5.916c-6.728,0-23.639.01-23.639.01A5.946,5.946,0,0,1,3670.446,8105.606Zm8.906,3.536h19.572c2.642,0,3.878-1.69,3.878-3.536v-2.651h-22.365C3680.437,8105.7,3680.653,8107.534,3679.352,8109.142Zm-13.189-3.807V8082.02h2.38v23.315Zm19.871-8.479c-.572-.71-.316-.855,1.916-6.339.179-.442-.71.383,17.222-14.114a1.189,1.189,0,0,1,1.671.179c3.64,4.5,3.813,4.479,3.591,5.252a4.568,4.568,0,0,1-.446,4.556c-.151.209-9.739,7.776-9.942,7.937l-1.478-1.864,9.562-7.577a2.519,2.519,0,0,0,.358-1.2l-15.313,12.381c-.381.307-.391.218-6.01,1.213a1.215,1.215,0,0,1-.2.018A1.2,1.2,0,0,1,3686.033,8096.856Zm2.84-2.294,1.506-.267-.93-1.152Zm1.952-3.5,1.879,2.325,10.468-8.462-1.879-2.325Zm12.318-9.959,1.879,2.325,2.6-2.1-1.877-2.325Zm-25.084,14.716v-2.379h4.757v2.379Zm-.477-7.137V8086.3h10.944v2.377Zm32.449-10.407c.515-.419-.153-1.25-.672-.831l-1.5-1.848a2.914,2.914,0,0,1,3.668,4.527Zm-43.87,1.366v-5.906a1.28,1.28,0,0,1,1.252-1.231h28.718c1.205,0,.959,1.4.959,4.283h-2.38v-1.9h-26.169v4.757Z",
    transform: "translate(-3666.162 -8072.502)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigned);
export default __webpack_public_path__ + "static/media/signed.775a4662.svg";
export { ForwardRef as ReactComponent };